import { MapPin } from "lucide-react";

// Hiring region, derived server-side from the job posting the candidate applied through.
export const RegionBadge = ({ region, testId, size = "sm" }) => {
  const set = !!region;
  const pad = size === "lg" ? "px-2.5 py-1 text-[13px]" : "px-1.5 py-0.5 text-[10.5px]";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold border whitespace-nowrap ${pad} ${
        set ? "bg-[#e8f3fb] text-[#005a94] border-[#b9dcf2]" : "bg-[#f5f6f8] text-[#6b7280] border-[#e7e9ee]"}`}
      title={set ? "Region from the job posting this candidate applied through" : "No job posting linked, so no region"}
      data-testid={testId}
    >
      <MapPin className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} />
      {set ? region : "Region: not set"}
    </span>
  );
};
